<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  created () {
    this.UPDATE_MENUS();
  },
  methods: {
    ...mapActions(["UPDATE_MENUS"])
  }
};
</script>

<style>
* {
  box-sizing: border-box;
}
html,
body {
  font-size: 14px;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.iconfont {
  margin-right: 7px;
}
.clearfix:after {
  clear: both;
  content: " ";
  display: block;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 5px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.3);
}

.el-dialog {
  margin: 0 auto;
  text-align: left;
}
.printHideCss {
  display: none !important;
}
.slot-header {
  border-bottom: 1px solid #e8eaec;
  margin-top: 56px;
  height: 80px;
  padding: 30px 0 0 30px;
  font-size: 20px;
}
.slot-table {
  overflow: auto !important;
  margin: 10px 5px 5px 20px;
}
.slot-foote {
  border-top: 1px solid #e8eaec;
  padding: 10px 10px;
}
.drawer-header {
  border-bottom: 1px solid #e8eaec;
  height: 100px;
  padding: 40px 0px;
  font-size: 20px;
}
.drawer-foot {
  padding: 10px 10px;
  height: 50px;
  /* border-top: 1px solid #e8eaec; */
  margin-bottom: -40px;
}

/* .el-form-item label:after {
  content: "";
  display: inline-block;
  width: 100%;
} */

/* .el-form-item__label {
  text-align: left;
  height: 50px;
} */

/* .el-form-item.is-required .el-form-item__label:before {
  content: none !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue